import React, { useState, useEffect, isValidElement } from 'react';
import { userApi } from '../../services/consts';
import {
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Card,
    CardTitle,
    CardBody
} from 'reactstrap';
import { tokenHeader, getUserToken } from "../../services/user-service";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const apiEndPoint = userApi;
const AddUser = (props) => {
    // const [id, setId] = useState(0);
    const [id, setId] = useState(0);
    const [userName, setName] = useState('');
    const [userEmail, setEmail] = useState('');
    const [userPassword, setPassword] = useState('');
    const [userStatus, setStatus] = useState('');
    const [userLevel, setLevel] = useState('');
    const [fetched, setFetched] = useState(false);
    const [label, setLabel] = useState('Add User');
    const [nameIsValid, setNameIsValid] = useState(false);
    const [emailIsValid, setEmailIsValid] = useState(false);
    const [passwordIsValid, setPasswordIsValid] = useState(false);

    var doCancel = () => {
        props.history.push('/users');
    }

    useEffect(() => {
        if (props.match.params.id != undefined && !fetched) {
            setFetched(true);
            setLabel('Update User');
            fetch(apiEndPoint + "/" + props.match.params.id, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    [tokenHeader]: getUserToken()
                }
            })
                .then(res => res.json())
                .then(function (result) {
                    setId(result.id);
                    setName(result.name);
                    setEmail(result.email);
                    setPassword(result.password);
                    setStatus(result.status);
                    setLevel(result.level);
                    // console.log(JSON.stringify(result));
                })
        }
    })

    var addUser = (e) => {
        e.preventDefault();
        let methodType = 'post';
        var user = {
            name: userName,
            email: userEmail,
            password: userPassword,
            status: userStatus,
            level: userLevel
        };
        // var formIsValid = true;
        if (user.name == '') {
            toast.error('Name is required');
            return setNameIsValid(true);
        } else if (user.email == '') {
            toast.error('Email is required');
            return setEmailIsValid(true);
        } else if (user.password == '') {
            toast.error('Password is required');
            return setPasswordIsValid(true);
        }
        if (id != 0) { //to update
            methodType = 'put';
            user.id = id;
        }
        fetch(apiEndPoint, {
            method: methodType,
            body: JSON.stringify(user),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                [tokenHeader]: getUserToken()
            }
        }).then(function (result) {
            if(result.status !== 500){
            toast.success('User added');
            setTimeout(() => {
                props.history.push('/users');
            }, 1000);
            }
            else{
                toast.error('User already exists');    
            }
        })
    };
    var onHandleChange = (e) => {
        // console.log("e.target.name:" + e.target.name);
        if (e.target.name == 'userName') {
            setName(e.target.value);
        } else if (e.target.name == 'userEmail') {
            setEmail(e.target.value);
        } else if (e.target.name == 'userPassword') {
            setPassword(e.target.value);
        } else if (e.target.name == 'userStatus') {
            setStatus(e.target.value);
        } else if (e.target.name == 'userLevel') {
            setLevel(e.target.value);
        }
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="mdi mdi-account-plus mr-2"> </i>
                    {label}
                </CardTitle>
                <CardBody className="">
                    <Form>
                        <FormGroup>
                            <Label>Name</Label>
                            <Input type="text" onChange={onHandleChange} value={userName} name="userName" id="userName" placeholder="Enter Your Name" />
                            {/* <span style={{color: "red"}}>{error}</span> */}
                        </FormGroup>
                        <FormGroup>
                            <Label>Email</Label>
                            <Input type="email" onChange={onHandleChange} value={userEmail} name="userEmail" id="userEmail" placeholder="Enter Your Email" />
                        </FormGroup>
                        <FormGroup>
                            <Label>Password</Label>
                            <Input type="password" onChange={onHandleChange} value={userPassword} name="userPassword" id="userPassword" placeholder="Enter Your Password" />
                        </FormGroup>
                        <FormGroup>
                            <Label>Status</Label>
                            <Input type="select" onChange={onHandleChange} value={userStatus} name="userStatus" id="userStatus">
                                <option hidden>Select Status</option>
                                <option>Active</option>
                                <option>Inactive</option>
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Level</Label>
                            <Input type="select" onChange={onHandleChange} value={userLevel} name="userLevel" id="userLevel">
                                <option hidden>Select Level</option>
                                <option>Admin</option>
                                <option>Sales</option>
                            </Input>
                        </FormGroup>
                        <Button onClick={addUser} color="success">{label}</Button>&nbsp;&nbsp;&nbsp;
                        <Button type="btn btn-secondary" onClick={doCancel}>Cancel</Button>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );
}

export default AddUser;